module.exports = __webpack_public_path__ + "assets/img/mecha-btn-878fb17e.png";